import { Button, Spinner } from 'react-bootstrap';
import _ from 'lodash';
import cx from 'classnames';

export default function NoDataFound({ className = '', title, height = null, children = null }) {
  return (
    <div
      className={className}
      style={{
        height: height || '285px',
      }}>
      {title ? <h6>No {title} are available.</h6> : null}
      {children}
    </div>
  );
}
